import axios from "axios";
import { refreshAccessToken } from "@/service/authService";

function interceptors() {
  const config = (setting) => setting;

  const error = async (erro) => {
    const statusCode = erro?.response?.status;
    const requestUrl = erro?.config?.url || "";
    const isLoginRequest = requestUrl.includes("/autenticacao");
    const isRecuperarSenha = requestUrl.includes("/recuperacao-senha");

    if (
      statusCode === 401 &&
      !isLoginRequest &&
      !isRecuperarSenha &&
      !erro.config._retry
    ) {
      erro.config._retry = true;

      try {
        const { novoAccessToken } = await refreshAccessToken(
          process.env.VUE_APP_API_BASE_URL ||
            "https://gex.dev.nerds.cloudns.be/api/",
        );

        erro.config.headers["Authorization"] = `Bearer ${novoAccessToken}`;

        return axios(erro.config);
      } catch (e) {
        window.localStorage.removeItem("auth_token");
        window.localStorage.removeItem("refresh_token");
        window.localStorage.removeItem("user");

        if (erro.config?.public) {
          if (erro.config.headers) {
            delete erro.config.headers["Authorization"];
          }
          return axios(erro.config);
        }

        return Promise.reject(e instanceof Error ? e : new Error(String(e?.message || e)));
      }
    }

    const responseErrors = {
      401: "Não autorizado, precisa se autenticar!",
      403: "Recurso proibido para o tipo de acesso!",
    };

    if (responseErrors[statusCode] && !isLoginRequest && !isRecuperarSenha) {
      console.error(responseErrors[statusCode]);
      if (statusCode === 401) {
        window.localStorage.removeItem("auth_token");
        window.localStorage.removeItem("refresh_token");
        window.localStorage.removeItem("user");
      }
    }

    return Promise.reject(erro);
  };

  return { config, error };
}

const api = () => {
  const apiBaseUrl =
    process.env.VUE_APP_API_BASE_URL || "https://gex.dev.nerds.cloudns.be/api/";

  const configAxios = axios.create({
    baseURL: apiBaseUrl,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });

  configAxios.interceptors.request.use((request) => {
    const token = window.localStorage.getItem("auth_token");

    const isPublicAuthRoute =
      request.url.includes("/autenticacao") ||
      request.url.includes("/alterar-email/") ||
      request.url.includes("/recuperacao-senha") ||
      request.url.includes("/controle-acesso/") ||
      (request.url.includes("/externos") &&
        request.method?.toLowerCase() === "post");

    if (token && !isPublicAuthRoute) {
      request.headers["Authorization"] = `Bearer ${token}`;
    }

    return request;
  });

  const { config, error: handleError } = interceptors();
  configAxios.interceptors.response.use((response) => {
    return response;
  }, handleError);

  return configAxios;
};

export const apiPlugin = {
  install(app, options) {
    app.config.globalProperties.$api = api();
  },
};

export default api();
